module.exports = __webpack_public_path__ + "static/media/view past paper.9793f93b.svg";